exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuContainer[data-v-9740c7bc] .nav-text.newly-increased{width:auto}", ""]);

// exports
